<template>
  <LcModal
    :close-triggers="['click-outside', 'close-button', 'escape']"
    :container-class="$style.modal"
    is-visible
    :tracking="{
      action: 'play_high_frequency_game',
      topicKey: 'high-frequency-game-prize-modal',
    }"
    @close="emit('close')"
  >
    <template #modal="{ setRef }">
      <LcCard :ref="setRef" body-class="p-none" radius="medium" role="dialog">
        <header>
          <HighFrequencyGamePrizeBannerInner
            class="high-frequency-game-prize-modal-banner"
            variant="modal"
          >
            <LcButton
              class="high-frequency-game-prize-modal-banner-close-button"
              icon="close"
              no-padding
              variant="tertiary"
              @click="emit('close')"
            />
          </HighFrequencyGamePrizeBannerInner>
        </header>

        <section class="high-frequency-game-prize-modal-body p-200">
          <HighFrequencyGamePrizeModalOptions />

          <HighFrequencyGamePrizeModalTable />

          <HighFrequencyGamePrizeModalHint class="mt-050" />
        </section>
      </LcCard>
    </template>
  </LcModal>
</template>

<script lang="ts" setup>
type Emits = {
  (e: 'close'): void
}

const emit = defineEmits<Emits>()
</script>

<style lang="scss" module>
.modal {
  > * {
    max-width: 22.45rem;
  }
}
</style>

<style lang="scss" scoped>
.high-frequency-game-prize-modal {
  &-body {
    min-width: 22rem;
    border: token('size/border/100') solid token('color/border/accent/win/win');
    border-radius: 0 0 token('size/radius/m') token('size/radius/m');
  }

  &-banner {
    padding: token('size/space/gap/200');
    border-radius: token('size/radius/m') token('size/radius/m') 0 0;

    &-close-button {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      height: auto;
      padding: token('size/space/gap/100') !important;
      border: none;
    }
  }
}
</style>
